import LOCATIONS from "@/data/locations.yml";
import ContentBlock from "@/components/content-block";

export default {
    components: { ContentBlock },
    data() {
        return {
            LOCATIONS,
        };
    },
};
